<template>
  <o-view :no-scroll="true">
    <o-view :bottom-padding="true">
      <o-nav-bar title="Cambio" :has-back-button="true" />
      <o-cambio-reservation
        label="Gent - Gent-Dampoort"
        type="Berline M"
        date="27/06/2019    12:00 - 13:00"
        :current="true"
        link="/sales/car/cambio/reservations/current"
      />
      <o-block-list title="Overige reservaties" :padding="false">
        <o-cambio-reservation
          v-for="reservation in reservations"
          :key="reservation.label"
          :label="reservation.label"
          :type="reservation.type || null"
          :date="reservation.date || null"
          link="/sales/car/cambio/reservations/edit"
        />
      </o-block-list>
      <o-block-list title="Afgelopen reservaties" :padding="false">
        <o-cambio-reservation
          v-for="reservation in reservations"
          :key="reservation.label"
          :label="reservation.label"
          :type="reservation.type || null"
          :date="reservation.date || null"
          :inactive="true"
        />
      </o-block-list>
    </o-view>
    <o-pay-button
      label="Nieuwe reservatie"
      to="/sales/car/cambio/reservations/new"
    />
  </o-view>
</template>

<script>
import OCambioReservation from '@/components/OCambioReservation.vue'
import OPayButton from '@/components/OPayButton.vue'

export default {
  name: 'CambioReservations',
  components: {
    OCambioReservation,
    OPayButton
  },
  data() {
    return {
      reservations: [
        {
          label: 'Gent - Gent-Dampoort',
          type: 'Berline M',
          date: '26/06/2019    11:00 - 17:00'
        },
        {
          label: 'Kortrijk - Graanmarkt',
          type: 'Berline M',
          date: '28/05/2019    15:00 - 17:00'
        },
        {
          label: 'Brussel - Kunstberg',
          type: 'Berline M',
          date: '15/05/2019    10:00 - 11:00'
        }
      ]
    }
  }
}
</script>
